/*
 * Copyright(c) 1995 - 2020 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */

import { InjectionToken } from '@angular/core';

export class Captcha {
    uuid: string;
    image: string;
}

export const CAPTCHA_URI = new InjectionToken<string>('CAPTCHA_URI');
